import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { addEntities } from "../../entities";
import {
  FETCH_REASON_FOR_LEAVING_FAILURE,
  FETCH_REASON_FOR_LEAVING_REQUEST,
  FETCH_REASON_FOR_LEAVING_SUCCESS
} from "../types";

const fetchReasonForLeaving = () => async (
  dispatch,
  getState,
  { api, schema }
) => {
  try {
    dispatch(createAction(FETCH_REASON_FOR_LEAVING_REQUEST)());
    const response = await api.factoring.fetchReasonForLeaving();
    const data = normalize(response.results, [schema.reasonForLeaving]);
    dispatch(addEntities(data.entities));
    dispatch(
      createAction(FETCH_REASON_FOR_LEAVING_SUCCESS)({
        items: data.result
      })
    );
    return response;
  } catch (err) {
    dispatch(createAction(FETCH_REASON_FOR_LEAVING_FAILURE)(err.message));
  }
};

export default fetchReasonForLeaving;
